/* unplugin-vue-components disabled */import script from "./Codegen.vue?vue&type=script&setup=true&lang=ts"
export * from "./Codegen.vue?vue&type=script&setup=true&lang=ts"

import "./Codegen.vue?vue&type=style&index=0&id=3098d582&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3098d582"]])

export default __exports__